import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

function normalizeReceivingBarcodeHistoryResponse(data) {
  const carton = data?.carton ?? data?.item ?? null;

  const item = carton
    ? {
        ...carton,
        product_name:
          carton.product_name ?? carton.assembly_item?.product_name ?? null,
        supplier_name:
          carton.supplier_name ??
          carton.invoice?.supplier?.name ??
          data?.invoice?.supplier?.name ??
          null,
      }
    : null;

  const invoice = data?.invoice ?? carton?.invoice ?? null;
  const histories = Array.isArray(data?.histories) ? data.histories : [];

  return {
    item,
    invoice,
    histories,
    cartonType: data?.carton_type ?? null,
  };
}

export function TraceabilityReceivingItemLookupViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [promoteModal, setPromoteModal] = useState({
    open: false,
    receivingItemId: null,
  });
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [histories, setHistories] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [lastBarcode, setLastBarcode] = useState("");

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const clearResult = () => {
    setItem(null);
    setInvoice(null);
    setHistories([]);
    setNotFound(false);
  };

  const onLookupBarcode = async function (barcode) {
    const trimmed = (barcode || "").trim();
    if (!trimmed) return;

    setLoading(true);
    setHasSearched(true);
    setLastBarcode(trimmed);
    clearResult();

    const callResult = await makePostApiCall(`fetchReceivingBarcodeHistory`, {
      barcode: trimmed,
    });

    if (callResult.success) {
      const normalized = normalizeReceivingBarcodeHistoryResponse(callResult.data);
      setItem(normalized.item);
      setInvoice(normalized.invoice);
      setHistories(normalized.histories);
    } else if (callResult.errorStatus === 404) {
      setNotFound(true);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "Could not fetch barcode history.");
    }

    setLoading(false);
  };

  const getPromoteReceivingDefaults = async function (receivingAssemblyItemId) {
    return makeGetApiCall(
      `promoteReceivingDefaults/${receivingAssemblyItemId}`,
    );
  };

  const promoteReceivingToPackaging = async function (payload) {
    return makePostApiCall("promoteReceivingToPackaging", payload);
  };

  const openPromoteModal = (receivingItemId) => {
    setPromoteModal({ open: true, receivingItemId });
  };

  const closePromoteModal = () => {
    setPromoteModal({ open: false, receivingItemId: null });
  };

  const handlePromoteSuccess = async () => {
    closePromoteModal();
    if (lastBarcode) {
      await onLookupBarcode(lastBarcode);
    }
  };

  return {
    loading,
    item,
    invoice,
    histories,
    hasSearched,
    notFound,
    onLookupBarcode,
    emptyModal,
    setEmptyModelOpen,
    promoteModal,
    openPromoteModal,
    closePromoteModal,
    handlePromoteSuccess,
    getPromoteReceivingDefaults,
    promoteReceivingToPackaging,
  };
}
